<template>
  <div id="app">
    <!-- 侧边栏 -->
    <div class="sidebar" :class="{ active: sidebarActive }">
      <div class="sidebar-header">
        <button class="new-chat-btn" @click="newChat">
          <i class="fas fa-plus"></i>
          新对话
        </button>
      </div>

      <div class="history-list" ref="historyList">
        <div
          v-for="(chatGroup, groupIndex) in historyTypeList"
          :key="groupIndex"
        >
          <span class="history_date">{{ chatGroup.date }}</span>
          <div
            v-for="(chat, chatIndex) in chatGroup.items"
            :key="chatIndex"
            class="history-item"
            :class="{ active: currentChatId === chat.id }"
            @click="selectChat(chat)"
          >
            <span class="history-item-title">{{ chat.title || "新对话" }}</span>
            <i
              class="el-icon-delete history_item_delete"
              @click.stop="deleteChat(chat)"
            ></i>
          </div>
        </div>

        <!-- 加载更多提示 -->
        <div v-if="loadingMore" class="loading-tips">
          <i class="el-icon-loading"></i> 加载中...
        </div>
        <div
          v-else-if="!hasMore && chatHistory.length > 0"
          class="loading-tips"
        >
          <i class="el-icon-minus"></i> 没有更多了
        </div>

        <div v-else-if="chatHistory.length === 0" class="empty-tips">
          <i class="el-icon-chat-line-round"></i>
          <p>暂无对话记录</p>
        </div>
      </div>

      <div class="sidebar-footer">
        <div class="user-profile">
          <div class="user-avatar">
            <i class="fas fa-user"></i>
          </div>
          <span class="user-name">{{userName}}</span>
        </div>
      </div>
    </div>

    <!-- 主内容区域 -->
    <div class="main-content">
      <div class="chat-header">
        <button class="mobile-menu-btn" @click="toggleSidebar">
          <i class="fas fa-bars"></i>
        </button>
        <div class="chat-title">
          {{ currentChat.title || "新对话" }}
        </div>
        <div class="chat-actions">
          <button
            v-if="isStreaming"
            class="stop-button"
            @click="stopStream"
            title="停止生成"
          >
            <i class="fas fa-stop"></i>
            停止
          </button>
          <button
            v-else-if="currentChat.messages.length > 1"
            class="clear-button"
            @click="clearCurrentChat"
            title="清空对话"
          >
            <i class="fas fa-eraser"></i>
            清空
          </button>
        </div>
      </div>

      <div class="chat-container" ref="chatContainer">
        <div
          v-for="(message, index) in currentChat.messages"
          :key="`message-${index}-${message.timestamp || index}`"
          class="message"
          :class="message.role"
        >
          <!-- <div class="message-avatar">
            <i v-if="message.role === 'user'" class="fas fa-user"></i>
            <i v-else class="fas fa-robot"></i>
          </div> -->
          <div class="message-content" v-if="message.content">
            <!-- <pre class="message-text">{{ message.content }}</pre> -->
             <!-- <pre class="message-text" v-if="isFirstSendAfterNewChat">{{ message.content?message.content:'你好！我是DeepSeek，很高兴为你服务。有什么我可以帮助你的吗？' }}</pre> -->
             <pre class="message-text">{{ message.content }}</pre> 
            <div v-if="message.timestamp" class="message-time">
              {{ formatTime(message.timestamp) }}
            </div>
          </div>
        </div>

        <!-- 正在输入动画 -->
        <div v-if="isTyping" class="message assistant">
          <!-- <div class="message-avatar">
            <i class="fas fa-robot"></i>
          </div> -->
          <div class="typing-indicator">
            <div class="typing-dots">
              <div class="typing-dot"></div>
              <div class="typing-dot"></div>
              <div class="typing-dot"></div>
            </div>
            <span>DeepSeek 正在思考...</span>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="currentChat.messages.length === 0" class="empty-chat">
          <div class="empty-icon">
            <i class="fas fa-comments"></i>
          </div>
          <h3>开始新的对话</h3>
          <p>输入消息开始与 DeepSeek AI 助手对话</p>
        </div>
      </div>

      <!-- 输入区域 -->
      <div class="input-area">
        <div class="input-container">
          <textarea
            v-model="inputMessage"
            class="chat-input"
            placeholder="输入消息... (Enter发送，Shift+Enter换行)"
            @keydown.enter.exact.prevent="sendMessage"
            @keydown.shift.enter="handleShiftEnter"
            @input="handleInput"
            ref="chatInput"
            :disabled="isStreaming"
            rows="1"
          ></textarea>
          <button
            class="send-button"
            @click="sendMessage"
            :disabled="!canSend"
            :class="{ disabled: !canSend }"
          >
            <i
              class="fas"
              :class="isStreaming ? 'fa-stop' : 'fa-paper-plane'"
            ></i>
          </button>
        </div>
        <div class="input-tips">
          <span v-if="isStreaming" class="streaming-tip"
            >DeepSeek 正在回复中...</span
          >
          <span v-else class="default-tip">DeepSeek 可以回答各种问题</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deepseekList, deepseekdel, deepseekChatMessage } from "@/api/deepseek";
const WELCOME_MESSAGE = "你好！我是DeepSeek，很高兴为你服务。有什么我可以帮助你的吗？";
import config from "../../../config/index";
import "@/assets/deepseek.css";
export default {
  name: "DeepSeekChat",

  data() {
    return {
      sidebarActive: false,
      inputMessage: "",
      isTyping: false,
      currentChatId: null,
      chatHistory: [],
      historyTypeList: [],
      platForm: "",
      userId: "",
      userName:'',
      oriApi:'',

      // 分页控制
      currentPage: 1,
      pageSize: 10,
      hasMore: true,
      loadingMore: false,

      // 流式传输控制
      streamController: null,
      isStreaming: false,
      currentAssistantMessage: "",
      scrollTimer: null,
      currentTypingQueue: [], // 待显示字符队列
      isAnimatingType: false, // 是否正在播放打字动画
      typingTimeout: null, // 打字动画定时器
      // 标记是否是新建对话后的首次发送
      isFirstSendAfterNewChat: false,
      refreshTimer: null,
        currentChatConversationId: null, // 👈 新增：用于保存当前聊天的 conversationId
    needRefreshHistory: false, // 确保这个变量存在
    refreshDebounceTimer: null, // 确保这个变量存在

    };
  },

  computed: {
    currentChat() {
      if (!this.currentChatId && this.chatHistory.length > 0) {
        // this.
        return this.chatHistory[0];
      }
      return (
        this.chatHistory.find((chat) => chat.id === this.currentChatId) ||
        this.getDefaultChat()
      );
    },

    canSend() {
      return this.inputMessage.trim() && !this.isStreaming;
    },
  },

  methods: {
    // 发送消息
    async sendMessage() {
      if (!this.canSend) return;

      const userMessage = this.inputMessage.trim();
      console.log("发送消息:", userMessage);

      // 添加用户消息
      this.addUserMessage(userMessage);

      // 更新标题（首次提问）
      this.updateChatTitle(userMessage);

      this.inputMessage = "";
      this.resetInputHeight();

      this.scrollToBottom();
      // 开始流式传输
      await this.startStreamResponse(userMessage);
    },

    // 添加用户消息
    addUserMessage(content) {
      this.currentChat.messages.push({
        role: "user",
        content: content,
        timestamp: Date.now(),
      });
    },

    // 更新聊天标题
    updateChatTitle(userMessage) {
      if (this.currentChat.messages.length === 2) {
        // 用户第一条消息
        this.currentChat.title =
          userMessage.substring(0, 20) + (userMessage.length > 20 ? "..." : "");
      }
    },

    // 开始流式响应
    async startStreamResponse(userMessage) {
      this.isTyping = true;
      this.isStreaming = true;

      // 👉 关键修复：重置流式状态
      this.currentAssistantMessage = ""; // 清空当前累积的回复
      this.currentTypingQueue = []; // 清空待显示队列
      if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
        this.typingTimeout = null;
      }
      this.isAnimatingType = false; // 停止任何正在进行的动画

      // 添加空的助手消息
      const assistantMessageIndex = this.currentChat.messages.length;
      this.currentChat.messages.push({
        role: "assistant",
        content: "",
        timestamp: Date.now(),
      });

      try {
        await this.streamChatCompletion(userMessage, assistantMessageIndex);
      } catch (error) {
        this.handleStreamError(error, assistantMessageIndex);
      } finally {
        this.isTyping = false;
        this.isStreaming = false;
        // 注意：这里不再需要操作 currentAssistantMessage，已在 handleStreamComplete 中处理
      }
    },

    // 流式聊天完成 - 针对你的SSE格式优化
    async streamChatCompletion(userMessage, messageIndex) {
      this.streamController = new AbortController();
      const signal = this.streamController.signal;
      // 👉 获取当前聊天的 conversationId
      const conversationId = this.currentChat.conversationId;
      try {
        const response = await fetch(
          config.apiHttpsUrl + "/general/api/chat/stream",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              message: userMessage,
              platForm: this.platForm,
              userId: this.userId,
              userName:this.userName,
              conversationId: conversationId,
            }),
            signal,
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        if (!response.body) {
          throw new Error("Response body is null");
        }

        await this.processStreamResponse(response, messageIndex);
      } catch (error) {
        if (error.name !== "AbortError") {
          throw error;
        }
      }
    },

    // 处理流式响应 - 优化SSE解析
    async processStreamResponse(response, messageIndex) {
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { done, value } = await reader.read();

        if (done) {
          console.log("流式传输完成");
          this.handleStreamComplete(messageIndex);
          break;
        }

        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;

        // 处理完整的SSE消息
        const messages = this.extractCompleteSSEMessages(buffer);
        buffer = messages.remainingBuffer;

        // 处理每个完整的SSE消息
        for (const message of messages.completeMessages) {
          this.processSSEMessage(message, messageIndex);
        }

        // 优化性能：批量更新UI
        await this.$nextTick();
      }
    },

    // 提取完整的SSE消息
    extractCompleteSSEMessages(buffer) {
      const completeMessages = [];
      let remainingBuffer = buffer;

      while (true) {
        // 查找两个连续换行符，表示一个完整的SSE消息结束
        const messageEndIndex = remainingBuffer.indexOf("\n\n");

        if (messageEndIndex === -1) {
          break;
        }

        // 提取完整的消息
        const messageText = remainingBuffer.substring(0, messageEndIndex);
        completeMessages.push(messageText);

        // 更新剩余缓冲区
        remainingBuffer = remainingBuffer.substring(messageEndIndex + 2);
      }

      return {
        completeMessages,
        remainingBuffer,
      };
    },

    // 处理单个SSE消息
    processSSEMessage(messageText, messageIndex) {
      console.log("原始SSE消息:", messageText);

      const lines = messageText.split("\n");
      let data = null;
      let eventType = "message"; // 默认事件类型

      for (const line of lines) {
        const trimmedLine = line.trim();
        if (!trimmedLine) continue;

        // 解析事件类型
        if (trimmedLine.startsWith("event:")) {
          eventType = trimmedLine.substring(6).trim();
        }
        // 解析数据
        else if (trimmedLine.startsWith("data:")) {
          const dataStr = trimmedLine.substring(5).trim();
          if (dataStr === "[DONE]") {
            // 流结束标记
            this.handleStreamComplete(messageIndex);
            return;
          }

          if (dataStr) {
            try {
              data = JSON.parse(dataStr);
            } catch (e) {
              console.warn("JSON解析失败:", dataStr, e);
              // 如果不是JSON，可能是纯文本内容
              if (dataStr.startsWith("{") || dataStr.startsWith("[")) {
                console.error("JSON解析错误的数据:", dataStr);
              } else {
                // 直接作为文本内容处理
                data = { content: dataStr, type: "text" };
              }
            }
          }
        }
      }

      // 处理解析后的数据
      if (data) {
        this.handleStreamData(data, eventType, messageIndex);
      }
    },

    // 处理流式数据 - 根据事件类型处理
    handleStreamData(data, eventType, messageIndex) {
      let content = "";

      if (data.content || data.text) {
        content = data.content || data.text;
      } else if (data.message && typeof data.message === "string") {
        content = data.message;
      } else if (typeof data === "string") {
        content = data;
      }

      if (!content || typeof content !== "string") return;
      if (data.conversationId) {
        this.currentChat.conversationId = data.conversationId;
      }
      // 不再直接追加，而是启动逐字动画
      this.typeTextGradually(content, messageIndex);
    },
    // 逐字显示函数
    typeTextGradually(text, messageIndex) {
      // 将新文本转为字符数组
      const chars = text.split("");

      // 添加到待显示队列
      this.currentTypingQueue.push(...chars);

      // 如果没有在动画中，则开始动画
      if (!this.isAnimatingType) {
        this.animateTyping(messageIndex);
      }
    },

    // 动画执行函数
    animateTyping(messageIndex) {
      if (this.isStreaming === false && this.currentTypingQueue.length === 0) {
    // ✅ 流结束且队列为空，表示动画彻底完成
    this.isAnimatingType = false;

    // 👉 在这里执行刷新逻辑
    if (this.isFirstSendAfterNewChat) {
      this.isFirstSendAfterNewChat = false;
      this.needRefreshHistory = true;
      this.scheduleHistoryRefresh();
    }

    // 可选：确保内容同步
    this.handleStreamComplete(messageIndex);
    return;
  }

  this.isAnimatingType = true;

  const container = this.$refs.chatContainer;

  const char = this.currentTypingQueue.shift();
  if (char !== undefined) {
    this.currentAssistantMessage += char;
    this.currentChat.messages[messageIndex].content = this.currentAssistantMessage;
    this.scheduleScrollToBottom();

    const delay = Math.random() * 40 + 30;
    this.typingTimeout = setTimeout(() => {
      this.animateTyping(messageIndex);
    }, delay);
  } else {
    if (this.isStreaming) {
      this.typingTimeout = setTimeout(() => {
        this.animateTyping(messageIndex);
      }, 50);
    } else {
      // ✅ 流已结束但队列空了，说明动画完成
      this.isAnimatingType = false;

      // 👉 在这里执行刷新逻辑
      if (this.isFirstSendAfterNewChat) {
        this.isFirstSendAfterNewChat = false;
        this.needRefreshHistory = true;
        this.scheduleHistoryRefresh();
      }

      this.handleStreamComplete(messageIndex);
    }
  }
    },
    // 在 methods 中定义
    refreshHistoryDebounced() {
      if (this.refreshTimer) {
        clearTimeout(this.refreshTimer);
      }
      this.refreshTimer = setTimeout(() => {
        this.getHistory();
      }, 800);
    },
    // 处理流完成
    handleStreamComplete(messageIndex) {
      if (
        messageIndex >= 0 &&
        messageIndex < this.currentChat.messages.length
      ) {
        this.currentChat.messages[messageIndex].content =
          this.currentAssistantMessage || "";
      }

      this.saveChatToHistory();
        // 流完成时确保滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom(true);
      });
    },
    // 添加智能刷新方法
    scheduleHistoryRefresh() {
      if (this.refreshDebounceTimer) {
        clearTimeout(this.refreshDebounceTimer);
      }

      // 延迟刷新，给用户更好的体验
      this.refreshDebounceTimer = setTimeout(() => {
        if (this.needRefreshHistory) {
          this.getHistory().finally(() => {
            this.needRefreshHistory = false;
          });
        }
      }, 1000);
    },

    // 处理流错误
    handleStreamError(error, messageIndex) {
      console.error("流式错误:", error);

      // 移除空的助手消息
      if (this.currentChat.messages[messageIndex]?.content === "") {
        this.currentChat.messages.splice(messageIndex, 1);
      }

      const errorMessage = this.getErrorMessage(error);
      this.currentChat.messages.push({
        role: "assistant",
        content: errorMessage,
        timestamp: Date.now(),
      });

      this.scrollToBottom();
    },

    // 获取错误消息
    getErrorMessage(error) {
      if (error.message.includes("HTTP error! status: 200")) {
        return "连接已建立，但数据处理异常";
      } else if (error.message.includes("fetch")) {
        return "网络连接失败，请检查网络设置";
      } else if (error.name === "AbortError") {
        return "生成已停止";
      } else {
        return `抱歉，请求失败：${error.message}`;
      }
    },

    // 停止流式传输
    stopStream() {
         if (this.streamController) {
    this.streamController.abort();
  }

  this.isStreaming = false;

  if (this.typingTimeout) {
    clearTimeout(this.typingTimeout);
    this.typingTimeout = null;
  }

  // 合并剩余字符并结束
  if (this.currentTypingQueue.length > 0) {
    this.currentAssistantMessage += this.currentTypingQueue.join("");
    this.currentTypingQueue = [];
  }

  // 更新最后一条助手消息
  const lastMsg = this.currentChat.messages[this.currentChat.messages.length - 1];
  if (lastMsg && lastMsg.role === "assistant") {
    lastMsg.content = this.currentAssistantMessage || lastMsg.content;
  }

  // 🔥 关键：重置流式状态
  this.isTyping = false;
  this.currentAssistantMessage = "";
  this.isAnimatingType = false;

  this.saveChatToHistory();

  this.$nextTick(() => {
    this.scrollToBottom(true);
  });
    },

    // 清空当前对话
    clearCurrentChat() {
      this.$modal
        .confirm("确定要清空当前对话吗？")
        .then(() => {
          this.currentChat.messages = [
            {
              role: "assistant",
              content:
                "你好！我是DeepSeek，很高兴为你服务。有什么我可以帮助你的吗？",
              timestamp: Date.now(),
            },
          ];
            this.$nextTick(() => {
          this.scrollToBottom(true);
        });
        })
        .catch(() => {});
    },

 // 新建聊天
    newChat() {
    // 1. 停止可能正在进行的流式请求
  this.stopStream();

  // 2. 强制重置流式状态（关键修复）
  this.isStreaming = false;
  this.isTyping = false;
  this.currentAssistantMessage = "";
  this.currentTypingQueue = [];
  this.isAnimatingType = false;
  if (this.typingTimeout) {
    clearTimeout(this.typingTimeout);
    this.typingTimeout = null;
  }

  // 3. 创建新聊天
  const newChat = this.getDefaultChat();

  // 4. 将新聊天添加到历史记录的开头
  this.chatHistory.unshift(newChat);
  // 更新分组列表
  this.historyTypeList = this.groupByDay(this.chatHistory);
  // 设置为当前聊天
  this.currentChatId = newChat.id;
  this.sidebarActive = false;

  // 5. 标记为首次发送，用于后续刷新历史（可选）
  this.isFirstSendAfterNewChat = true;

  // 6. 确保视图滚动到底部
  this.$nextTick(() => {
    this.scrollToBottom(true);
  });
    },

    // 选择聊天
    selectChat(chat) {
      this.stopStream();
      this.currentChatId = chat.id;

      // 👉 修复：确保 conversationId 正确设置
      const selectedChat = this.chatHistory.find((c) => c.id === chat.id);
      if (selectedChat) {
        this.currentChat.conversationId = selectedChat.id;
      }
      console.log("当前聊天ID:", this.currentChat);
      this.getMessageInfo();
      this.sidebarActive = false;
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },

    // 获取默认聊天
    getDefaultChat() {
       const defaultChat = {
    id: Date.now(),
    title: "新对话",
    conversationId: null,
    messages: [
      {
        role: "assistant",
        content: WELCOME_MESSAGE,
        timestamp: Date.now(),
      },
    ],
    updatedAt: new Date().toISOString(),
  };
  
  // 使用 JSON 方法创建新对象
  return JSON.parse(JSON.stringify(defaultChat));
    },

    // 保存聊天到历史记录
    saveChatToHistory() {
      // 在实际项目中，这里应该调用保存API
    // 查找 chatHistory 中是否有对应的聊天记录
  const index = this.chatHistory.findIndex(chat => chat.id === this.currentChat.id);
  if (index !== -1) {
    // 如果存在，则用 currentChat 的最新状态替换它
    // 注意：这里我们使用 JSON.parse(JSON.stringify()) 来创建一个深拷贝
    // 以确保响应式更新
    this.$set(this.chatHistory, index, JSON.parse(JSON.stringify(this.currentChat)));
  } else {
    // 如果不存在（理论上不应该发生，但为了安全）
    this.chatHistory.unshift(JSON.parse(JSON.stringify(this.currentChat)));
  }
  // 重新分组以更新侧边栏显示
  this.historyTypeList = this.groupByDay(this.chatHistory);
      console.log("保存对话到历史记录");
    },

    // 输入处理
    handleInput() {
      this.autoResize();
    },

    handleShiftEnter() {
      this.inputMessage += "\n";
      this.autoResize();
    },

    // 自动调整输入框高度
    autoResize() {
      this.$nextTick(() => {
        const el = this.$refs.chatInput;
        el.style.height = "auto";
        el.style.height = Math.min(el.scrollHeight, 200) + "px";
      });
    },

    resetInputHeight() {
      this.$nextTick(() => {
        const el = this.$refs.chatInput;
        el.style.height = "auto";
      });
    },

    // 滚动控制
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    scheduleScrollToBottom() {
      if (!this.scrollTimer) {
        this.scrollTimer = setTimeout(() => {
          this.scrollToBottom();
          this.scrollTimer = null;
        }, 100);
      }
    },

    // 时间格式化
    formatTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hour = String(date.getHours()).padStart(2, "0");
      const minute = String(date.getMinutes()).padStart(2, "0");
      const second = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },

    // 历史记录相关方法
    async getHistory() {
      try {
        this.loadingMore = true;
        const res = await deepseekList({
          platForm: this.platForm,
          userId: this.userId,
        //   page: this.currentPage,
        //   size: this.pageSize,
        });

        this.processHistoryResponse(res.data.data);

        // 👉 修复：确保当前选中的聊天 conversationId 正确
        if (this.currentChatId) {
          const current = this.chatHistory.find(
            (chat) => chat.id === this.currentChatId
          );
          if (current && current.conversationId) {
            this.currentChat.conversationId = current.id;
          }
        }
      } catch (err) {
        console.error("加载失败:", err);
        this.$message.warning("加载更多失败");
        this.currentPage = Math.max(1, this.currentPage - 1);
      } finally {
        this.loadingMore = false;
        this.needRefreshHistory = false;
      }
    },

    // 修改 processHistoryResponse 方法
    processHistoryResponse(newData) {
      if (this.currentPage === 1) {
        this.chatHistory = (newData || []).map((chat) => ({
          ...chat,
          conversationId: chat.conversationId || chat.conversation_id || null,
          messages: chat.messages || [],
        }));
      } else {
        const data = (newData || []).map((chat) => ({
          ...chat,
          conversationId: chat.conversationId || chat.conversation_id || null,
          messages: chat.messages || [],
        }));
        if (data.length === 0) {
          this.hasMore = false;
        } else {
          this.chatHistory.push(...data);
        }
      }

      this.historyTypeList = this.groupByDay(this.chatHistory);

      // 👉 修复：确保当前聊天状态正确
      if (this.chatHistory.length === 0) {
        this.newChat();
      } else if (
        !this.currentChatId ||
        !this.chatHistory.find((chat) => chat.id === this.currentChatId)
      ) {
        // 如果当前聊天不存在于新历史中，切换到第一个
        this.currentChatId = this.chatHistory[0].id;
        this.currentChat.conversationId = this.chatHistory[0].id;
        this.getMessageInfo();
      } else {
        // 确保当前聊天的 conversationId 同步
        const current = this.chatHistory.find(
          (chat) => chat.id === this.currentChatId
        );
        if (current) {
          this.currentChat.conversationId = current.id;
        }
      }
    },
    getMessageInfo() {
      deepseekChatMessage({ conversationId: this.currentChatId }).then((res) => {
    const data = res.data.data;
    data.forEach((e) => {
      e.timestamp = Date.parse(e.createdAt);
    });
    // ✅ 先找到正确的 chat 对象再赋值
    const chat = this.chatHistory.find(c => c.id === this.currentChatId);
    if (chat) {
      chat.messages = data;
    }
  });
    },

    async deleteChat(chat) {
      try {
        await this.$modal.confirm("是否确认删除？");
        await deepseekdel({ id: chat.id });

        // 从历史记录中移除
        const index = this.chatHistory.findIndex((c) => c.id === chat.id);
        if (index !== -1) {
          this.chatHistory.splice(index, 1);
        }

        // 如果删除的是当前聊天，切换到第一个
        if (this.currentChatId === chat.id) {
          this.currentChatId = this.chatHistory[0]?.id || null;
          if (!this.currentChatId) {
            this.newChat();
          }
        }

        this.historyTypeList = this.groupByDay(this.chatHistory);
        this.$modal.msgSuccess("删除成功");
      } catch (error) {
        // 用户取消或删除失败，不做任何操作
      }
    },

    groupByDay(data) {
      const grouped = {};
      data.forEach((item) => {
        const date = item.updatedAt
          ? item.updatedAt.split(" ")[0]
          : new Date().toISOString().split("T")[0];
        if (!grouped[date]) {
          grouped[date] = [];
        }
        grouped[date].push(item);
      });

      return Object.keys(grouped)
        .sort((a, b) => new Date(b) - new Date(a))
        .map((date) => ({
          date: date,
          items: grouped[date],
        }));
    },

    handleScroll() {
      const el = this.$refs.historyList;
      if (!el || this.loadingMore || !this.hasMore) return;

      if (el.scrollHeight - el.scrollTop - el.clientHeight < 50) {
        // this.loadMore();
      }
    },

    loadMore() {
      if (this.loadingMore || !this.hasMore) return;
      this.currentPage++;
      this.loadingMore = true;
      this.getHistory();
    },

    toggleSidebar() {
      this.sidebarActive = !this.sidebarActive;
    },
  },

  mounted() {
    this.userId = this.$route.query.userId
    this.userName = this.$route.query.userName
    this.platForm = this.$route.query.platForm
    this.oriApi = this.$route.query.oriApi
    this.getHistory();
    this.scrollToBottom();
    const historyListEl = this.$refs.historyList;
    if (historyListEl) {
      historyListEl.addEventListener("scroll", this.handleScroll);
    }
  },

  beforeDestroy() {
    const historyListEl = this.$refs.historyList;
    if (historyListEl) {
      historyListEl.removeEventListener("scroll", this.handleScroll);
    }

    this.stopStream();
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
  },
};
</script>

<style scoped>
</style>